import { render } from "./NewFromImport.vue?vue&type=template&id=756dfe04&scoped=true"
import script from "./NewFromImport.vue?vue&type=script&lang=js"
export * from "./NewFromImport.vue?vue&type=script&lang=js"

import "./NewFromImport.vue?vue&type=style&index=0&id=756dfe04&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756dfe04"]])

export default __exports__